import { render, staticRenderFns } from "./mIndex.vue?vue&type=template&id=108c30c2&scoped=true&"
import script from "./mIndex.vue?vue&type=script&lang=js&"
export * from "./mIndex.vue?vue&type=script&lang=js&"
import style0 from "./mIndex.vue?vue&type=style&index=0&id=108c30c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c30c2",
  null
  
)

export default component.exports